import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import GuidePage from "@/pages/guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article",
    element: <Article />,
  },
  {
    path: "/guide/:slug",
    element: <GuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;